import React from "react";

import { Badge } from "../ui/badge";
import { cn } from "../../lib/utils";

// O chip de situação de orçamento, pedido e proposta — um desenho só.
//
// Os catálogos de status continuam separados por entidade (os estados são
// mesmo diferentes); o que converge aqui é a renderização, que antes era um
// <span> cru com quatro estilos diferentes espalhados pelas telas.
const SituacaoBadge = ({ situacao, className }) => {
	if (!situacao) return null;

	return (
		<Badge
			variant="outline"
			className={cn("whitespace-nowrap", situacao.classe, className)}
		>
			{situacao.rotulo}
		</Badge>
	);
};

export default SituacaoBadge;
